module.exports = __webpack_public_path__ + "img/fr_Ecran 3.d97932be.png";